module.exports = __webpack_public_path__ + "images/花筑院子全景_05.jpg?v=4a050e02";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_05.jpg
 ** module id = 76
 ** module chunks = 1 2
 **/